import { useRouter } from 'next/router'
import { useCallback, useEffect, useState } from 'react'

import { POST_TYPE } from '@/constants/postv2'
import { DehaatPosts } from '@/models/Posts'
import fetchRelatedPosts from '@/utils/api/fetchRelatedPosts'
import { fixNextPageUrl } from '@/utils/helper'

const useRelatedPosts = (slug: string, postType?: string) => {
  const [relatedPosts, setRelatedPosts] = useState<DehaatPosts[]>([])
  const [nextPageUrl, setNextPageUrl] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const [loadingNext, setLoadingNext] = useState(false)
  const [error, setError] = useState('')

  const { locale } = useRouter()

  const fetchNext = useCallback(async () => {
    if (nextPageUrl) {
      setLoadingNext(true)
      const response = await fetchRelatedPosts(nextPageUrl)
      if (response) {
        const { results, next } = response
        setRelatedPosts((prev) => prev.concat(...results))
        setNextPageUrl(fixNextPageUrl(next) || null)
        setError('')
      } else {
        //TODO:: handle rejection
        setError('unable_to_fetch_more_data_caption')
      }
      setLoadingNext(false)
    }
  }, [nextPageUrl])

  const getRelatedPosts = useCallback(async () => {
    setLoading(true)
    const url =
      postType === 'community'
        ? `/community/v2/posts/${slug}/related`
        : `feed/v1/post/${slug}/related?`
    const response = await fetchRelatedPosts(url, {
      type: postType === 'community' ? '' : POST_TYPE.Blog,
      lang: locale,
      page: 1,
      page_size: 3,
    })
    if (response) {
      const { results, next } = response
      setRelatedPosts(results)
      setNextPageUrl(fixNextPageUrl(next) || null)
      setError('')
    } else {
      //TODO:: Handle rejection
      setError('unable_to_fetch_data_caption')
    }
    setLoading(false)
  }, [locale, slug, postType])

  useEffect(() => {
    getRelatedPosts()
  }, [getRelatedPosts])

  return { fetchNext, loading, loadingNext, relatedPosts, nextPageUrl, error }
}

export default useRelatedPosts
